export default function EmptyState({ title = 'No hay resultados', description }) {
  return (
    <div className="state-block empty">
      <div className="empty-icon">∅</div>
      <p className="empty-title">{title}</p>
      {description ? <p className="empty-desc">{description}</p> : null}
    </div>
  );
}
